// ============================================================
// api/billing.js — Platform-10 admin endpoints (admin-tenant).
// Backend: admin-billing-rate-card / admin-billing-preview /
// admin-client-billing. Money is PENCE/INT on the wire.
// ============================================================
import { apiGet, apiPost, apiPatch, apiPut, apiDelete } from './client';

// Platform-default rate card (current effective).
export const getRateCard = () => apiGet('/mgmt/admin/billing/rate-card');
// Set a rate item's price (new effective row). { pricePence, effectiveFrom? }
export const setRatePrice = (itemKey, body) => apiPost(`/mgmt/admin/billing/rate-card/${encodeURIComponent(itemKey)}`, body);

// Dry-run preview across all billing-enabled clients. period = 'YYYY-MM'.
export const getBillingPreview = (period) => apiGet('/mgmt/admin/billing/preview', period ? { period } : {});

// Per-client: config + overrides + current-month preview.
export const getClientBilling = (clientId) => apiGet(`/mgmt/admin/clients/${clientId}/billing`);
// Set BillingEnabled / contact. { billingEnabled?, billingContactName?, billingContactEmail? }
export const setClientBillingConfig = (clientId, body) => apiPatch(`/mgmt/admin/clients/${clientId}/billing`, body);
// Per-client price override. { pricePence, effectiveFrom? }
export const setClientOverride = (clientId, itemKey, body) => apiPut(`/mgmt/admin/clients/${clientId}/billing/overrides/${encodeURIComponent(itemKey)}`, body);
export const clearClientOverride = (clientId, itemKey) => apiDelete(`/mgmt/admin/clients/${clientId}/billing/overrides/${encodeURIComponent(itemKey)}`);

// ── money helpers (pence <-> £) ──
export const poundsFromPence = (pence) => (Number(pence || 0) / 100).toFixed(2);
export function penceFromPounds(str) {
  const n = parseFloat(String(str).replace(/[£,\s]/g, ''));
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.round(n * 100);
}
